/** Render-only paint and trim; solid geometry lives in level.ts. */
export const FARM_VEHICLE = {
  tractor: 0xa4382b,
  trailer: 0x47754d,
  frame: 0x303630,
  tyre: 0x20221f,
  rim: 0xd8d0ab,
  glass: 0x819fa4,
  hay: 0xb3a16a,
  lamp: 0xffe9ac,
} as const;

/** Render-only modelling dimensions; meshes scale to the actual collision boxes. */
export const FARM_VEHICLE_MODEL = {
  trailer: { x: 13.25, y: 3.3, z: 3.4 },
  tractor: { x: 6.8, y: 3.5, z: 3.4 },
} as const;
